/**
 * @flow
 * @relayHash eeb5148a3be8092e70cfc730a11d504a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReportsQueryVariables = {||};
export type ReportsQueryResponse = {|
  +reports: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +description: ?string,
  |}>
|};
export type ReportsQuery = {|
  variables: ReportsQueryVariables,
  response: ReportsQueryResponse,
|};
*/


/*
query ReportsQuery {
  reports {
    id
    name
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "reports",
    "storageKey": null,
    "args": null,
    "concreteType": "Report",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReportsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ReportsQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ReportsQuery",
    "id": null,
    "text": "query ReportsQuery {\n  reports {\n    id\n    name\n    description\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ced75b2cecd2f8100cfa0328515d044a';
module.exports = node;
